import { combineReducers } from 'redux';
import alert  from './alert.reducer';
import notification  from './notification.reducer';

const rootReducer = combineReducers({
  notification,
  alert
});

export default rootReducer;